import { useMutation } from '@apollo/client';
import { AutoCreate } from '@bakerweb/models';
import { toast } from 'react-toastify';
import { CREATE_AUTO_MUTATION } from '../graphql/mutations/createAuto';

export function useCreateAuto() {
  const [createAutoMutation, { data, loading, error }] = useMutation(CREATE_AUTO_MUTATION);

  const createAuto = async (autoData: AutoCreate) => {
    try {
      const result = await createAutoMutation({
        variables: {
          autoCreateDto: autoData
        }
      });
      toast.success('Your inquiry is on the way!');
      return result;
    } catch (err) {
      toast.error(`There was an error sending your request. Please try again.`);
      return null;
    }
  };

  return {
    createAuto,
    data,
    loading,
    error
  };
}
